import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { OAuthService } from 'angular-oauth2-oidc';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router, private oAuthService: OAuthService, private dialog: MatDialog) {}
 
  ///Interceptor que sirve para configurar en todas las autenticaciones generar un token
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let req = request;
    const token = localStorage.getItem('token');
    if (token) {
      req = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          return this.handle401Error();
        } else{
          return throwError(() => err);
        }
      })
    );
  }

  private handle401Error(): Observable<any> {
    /*Swal.fire({
      icon: 'info',
      titleText: ' Tu sesión ha expirado',
      confirmButtonText: 'Ok',
    }).then((results) => {
      if (results.isConfirmed) {
        localStorage.clear();
        this.oAuthService.logOut();
        this.router.navigateByUrl('login');
      }
    });
    return EMPTY;*/
    
    // Cerrar todos los modals abiertos y limpiar el local storage
    this.dialog.closeAll();
    localStorage.clear();
    sessionStorage.clear();
    this.oAuthService.logOut();
    this.router.navigateByUrl('login');
    return EMPTY;
  }
}
